import { render, staticRenderFns } from "./pagerIndex.vue?vue&type=template&id=27c029f6"
import script from "./pagerIndex.vue?vue&type=script&lang=js"
export * from "./pagerIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports